import { useMutation } from "@tanstack/react-query";
import type { ClientResponseError } from "pocketbase";
import { SERVICE_API } from "@/lib/consts";

type PushSentResponse = {
	success: boolean;
	sent: number;
	failed: number;
	invalidTokensRemoved: number;
};

export function useSendPushNotification() {
	return useMutation<
		PushSentResponse,
		Error | ClientResponseError,
		{ notificationId: string; isProd: boolean }
	>({
		mutationKey: ["push"],
		mutationFn: async ({ notificationId, isProd }) => {
			const res = await fetch(
				`${SERVICE_API}/api/push/send/${isProd ? "prod" : "test"}`,
				{
					method: "POST",
					body: JSON.stringify({ notification_id: notificationId }),
					credentials: "include",
					headers: {
						"Content-Type": "application/json",
					},
				},
			);

			const json = (await res.json()) as PushSentResponse;
			return json;
		},
	});
}
